import { BuildingSpecification } from '../../specification/buildings/BuildingSpecification';

export const buildingHasNoCase = (building: BuildingSpecification): boolean =>
  building.cases.length === 0;
